import Modal from '../../../../empreenderUI/ui/Modal/Modal';
import ModalContent, { ModalTitle } from '../../../../empreenderUI/ui/Modal/ModalContent';
import { FileUp, Images, Link2, KeyRound } from 'lucide-react';
import { Button } from '../../../../empreenderUI/ui/Button';
import { useSelector } from 'react-redux';
import { translations } from '../../../../utils/language';

const KEYS_ALLOWED_CHAVES = ['DJLWwaOHw', 'DJLW8WOXI', 'DJL28ZOQ', 'DJL24YPw'];

const tiles = [
  {
    kind: 'file',
    icon: FileUp,
    titleKey: 'products-th-arquivos',
    descKey: 'products-add-desc-file',
    soon: false,
  },
  {
    kind: 'gallery',
    icon: Images,
    titleKey: 'Galeria',
    descKey: 'products-add-desc-gallery',
    soon: false,
  },
  {
    kind: 'link',
    icon: Link2,
    titleKey: 'products-link-singular',
    descKey: 'products-add-desc-link',
    soon: false,
  },
  {
    kind: 'key',
    icon: KeyRound,
    titleKey: 'products-add-keys-title',
    descKey: 'products-add-desc-keys',
    soon: false,
    requiresChave: KEYS_ALLOWED_CHAVES,
  },
];

function getChaveEmpreender() {
  try {
    return JSON.parse(localStorage.getItem('depoimentos@login'))?.user?.chave_empreender || '';
  } catch {
    return '';
  }
}

export default function ModalAddContent({ open, onOpenChange, contextLabel, onSelect }) {
  const language = useSelector((state) => state.reducerLanguage);
  const lang = language?.data || 'pt';
  const chaveEmpreender = getChaveEmpreender();
  const visibleTiles = tiles.filter((tile) => !tile.requiresChave || tile.requiresChave.includes(chaveEmpreender));

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent className='!h-auto max-h-[90vh] w-[min(520px,92vw)] !max-w-none'>
        <ModalTitle>{translations['products-add-content'][lang]}</ModalTitle>
        {contextLabel && <p className='text-sm text-gray-500 mt-1'>{contextLabel}</p>}

        <div className='grid grid-cols-2 gap-3 mt-6'>
          {visibleTiles.map((tile) => {
            const Icon = tile.icon;
            return (
              <button
                key={tile.kind}
                type='button'
                disabled={tile.soon}
                onClick={() => {
                  if (tile.soon) return;
                  onSelect?.(tile.kind);
                }}
                className={`border border-gray-200 rounded-xl p-5 text-center transition-colors ${tile.soon ? 'opacity-60 cursor-not-allowed bg-gray-50' : 'bg-white hover:border-blue-500 hover:bg-blue-50/40 cursor-pointer'}`}
              >
                <Icon className='mx-auto size-6 text-blue-600' strokeWidth={1.75} />
                <b className='block mt-3 mb-1.5 text-sm text-gray-900 font-semibold'>{translations[tile.titleKey][lang]}</b>
                <small className='block text-xs text-gray-500 leading-snug'>{tile.soon ? translations['products-soon'][lang] : translations[tile.descKey][lang]}</small>
              </button>
            );
          })}
        </div>

        <div className='flex justify-end mt-6'>
          <Button variant='outline' onClick={() => onOpenChange?.(false)}>
            {translations['common-cancel'][lang]}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
